var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/setting-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "setting-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.5374 4.60584H8.51491C8.30366 4.60584 8.13574 4.43792 8.13574 4.22667C8.13574 4.01542 8.30366 3.8475 8.51491 3.8475H11.5374C11.7487 3.8475 11.9166 4.01542 11.9166 4.22667C11.9166 4.43792 11.7487 4.60584 11.5374 4.60584Z",
    fill: "#1A1C1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.47742 4.60584H1.46242C1.25117 4.60584 1.08325 4.43792 1.08325 4.22667C1.08325 4.01542 1.25117 3.8475 1.46242 3.8475H3.47742C3.68867 3.8475 3.85659 4.01542 3.85659 4.22667C3.85659 4.43792 3.68325 4.60584 3.47742 4.60584Z",
    fill: "#1A1C1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.49261 6.36626C6.67427 6.36626 7.63219 5.40834 7.63219 4.22668C7.63219 3.04502 6.67427 2.0871 5.49261 2.0871C4.31095 2.0871 3.35303 3.04502 3.35303 4.22668C3.35303 5.40834 4.31095 6.36626 5.49261 6.36626Z",
    fill: "#1A1C1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.5375 10.1471H9.52248C9.31123 10.1471 9.14331 9.97918 9.14331 9.76793C9.14331 9.55668 9.31123 9.38876 9.52248 9.38876H11.5375C11.7487 9.38876 11.9166 9.55668 11.9166 9.76793C11.9166 9.97918 11.7487 10.1471 11.5375 10.1471Z",
    fill: "#1A1C1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.48492 10.1471H1.46242C1.25117 10.1471 1.08325 9.97918 1.08325 9.76793C1.08325 9.55668 1.25117 9.38876 1.46242 9.38876H4.48492C4.69617 9.38876 4.86408 9.55668 4.86408 9.76793C4.86408 9.97918 4.69075 10.1471 4.48492 10.1471Z",
    fill: "#1A1C1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M7.5075 11.9129C8.68916 11.9129 9.64709 10.955 9.64709 9.77334C9.64709 8.59168 8.68916 7.63376 7.5075 7.63376C6.32584 7.63376 5.36792 8.59168 5.36792 9.77334C5.36792 10.955 6.32584 11.9129 7.5075 11.9129Z",
    fill: "#1A1C1E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.39327f2ebcfad88233bba98cdb9962d1.svg";
export { ForwardRef as ReactComponent };